export default __webpack_public_path__ + "static/media/otp.80c4318e.png";